module.exports = __webpack_public_path__ + "media/limitations/superficie-4a1468af.png";